import React, { PureComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faEllipsisH } from '@fortawesome/free-solid-svg-icons';

import TimeLabel from '../../../../UI/TimeLabel/TimeLabel';

class GridMovimientos extends PureComponent {

    render() {
        const columnas = [
            { nombre: 'Sucursal', ancho: 2, className: '' },
            { nombre: 'Número', ancho: 1, className: '' },
            { nombre: 'Orden', ancho: 1, className: '' },
            { nombre: 'Despacho', ancho: 1, className: '' },
            { nombre: 'Factura', ancho: 1, className: '' },
            { nombre: 'Ruta', ancho: 1, className: '' },
            { nombre: 'T. Rest', ancho: 1, className: '' },
            { nombre: 'Mov. Inv', ancho: 1, className: '' },
            { nombre: 'Transporte', ancho: 2, className: '' },
            { nombre: <FontAwesomeIcon icon={faEllipsisH} />, ancho: 1, className: 'text-center' }
        ];

        return (
            <div className="table-monitor movimiento">
                <div className="row th" onClick={() => this.props.onClick(0, null, null)}>
                    {
                        columnas.map((columna, index) => {
                            return (<div className={"col-" + columna.ancho + " " + columna.className} key={index}>{columna.nombre}</div>)
                        })
                    }
                </div>
                {
                    this.props.movimientos.map((movimiento, index) => {
                        let sucursalValor = <p className="margin-left">{movimiento.Sucursal_Nombre}</p>;
                        if (movimiento.Factura) {
                            sucursalValor = <p className="factura"><FontAwesomeIcon icon={faFileAlt} />{movimiento.Sucursal_Nombre}</p>;
                        }

                        const tiempos = {
                            Orden: movimiento.Tiempo_Orden,
                            EstadoOrden: movimiento.Estado_Tiempo_Orden,
                            Despacho: movimiento.Tiempo_Despacho,
                            EstadoDespacho: movimiento.Estado_Tiempo_Despacho,
                            Factura: movimiento.Tiempo_Factura,
                            EstadoFactura: movimiento.Estado_Tiempo_Factura,
                            Ruta: movimiento.Tiempo_Ruta,
                            EstadoRuta: movimiento.Estado_Tiempo_Ruta
                        };

                        return (
                            <div className="row th row-movimiento" key={index} onClick={() => this.props.onClick(movimiento.Sucursal_Id, movimiento.Sucursal_Nombre, tiempos)}>
                                <div className={"col-" + columnas[0].ancho}>
                                    {sucursalValor}
                                </div>
                                <div className={"col-" + columnas[1].ancho}>
                                    <p>{movimiento.Orden_Id}</p>
                                </div>
                                <div className={"col-" + columnas[2].ancho}>
                                    <TimeLabel tiempo={movimiento.Tiempo_Orden}
                                        estado={movimiento.Estado_Tiempo_Orden}
                                        activo={!movimiento.Orden_Finalizada && movimiento.Tiempo_Orden > 0 && movimiento.Tiempo_Despacho === 0}
                                        cambioDireccion={false} >
                                    </TimeLabel>
                                </div>
                                <div className={"col-" + columnas[3].ancho}>
                                    <TimeLabel tiempo={movimiento.Tiempo_Despacho}
                                        estado={movimiento.Estado_Tiempo_Despacho}
                                        activo={!movimiento.Orden_Finalizada && movimiento.Tiempo_Despacho > 0 && movimiento.Tiempo_Factura === 0}
                                        cambioDireccion={false} >
                                    </TimeLabel>
                                </div>
                                <div className={"col-" + columnas[4].ancho}>
                                    <TimeLabel tiempo={movimiento.Tiempo_Factura}
                                        estado={movimiento.Estado_Tiempo_Factura}
                                        activo={!movimiento.Orden_Finalizada && movimiento.Tiempo_Factura > 0 && movimiento.Tiempo_Ruta === 0}
                                        cambioDireccion={false} >
                                    </TimeLabel>
                                </div>
                                <div className={"col-" + columnas[5].ancho}>
                                    <TimeLabel tiempo={movimiento.Tiempo_Ruta}
                                        estado={movimiento.Estado_Tiempo_Ruta}
                                        activo={!movimiento.Orden_Finalizada && movimiento.Tiempo_Ruta > 0}
                                        cambioDireccion={false} >
                                    </TimeLabel>
                                </div>
                                <div className={"col-" + columnas[6].ancho}>
                                    <TimeLabel tiempo={movimiento.Tiempo_Retraso}
                                        estado={movimiento.Estado_Tiempo_Retraso}
                                        activo={!movimiento.Orden_Finalizada && movimiento.Tiempo_Retraso !== 0}
                                        cambioDireccion={true} >
                                    </TimeLabel>
                                </div>
                                <div className={"col-" + columnas[7].ancho + " text-center"}>
                                    <p>{movimiento.Movimiento_Id}</p>
                                </div>
                                <div className={"col-" + columnas[8].ancho}>
                                    <p>{movimiento.Repartidor}</p>
                                </div>
                                <div className={"col-" + columnas[9].ancho + " text-center"}>
                                    <p>{columnas[9].nombre}</p>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )
    }
};

export default GridMovimientos;